import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {useAuthenticationStatus} from "../Authentication/AuthenticationStatusProvider";
import './Dashboard.css'
import {logout} from "../Utils/APIUtils";
import {useTranslation} from "react-i18next";

import packageJson from '../../package.json';

const Dashboard = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {authenticationStatus} = useAuthenticationStatus();
    //useProtectedComponent(navigate, '/login');

    if (authenticationStatus.isAuthenticated) {
        return (
            <div className={'dashboard-container'}>
                <div className={'dashboard'}>
                    {authenticationStatus.user.agentCodes && authenticationStatus.user.agentCodes.length > 0 &&
                        <div>
                            <a href="/enrolment">
                            <span className="material-symbols-outlined">
                                add_notes
                            </span>

                                {t('New Enrolment')}
                            </a>
                        </div>
                    }
                    {authenticationStatus.user.agentCodes && authenticationStatus.user.agentCodes.length > 0 &&
                        <div>
                            <a href="/enrolments">
                                <span className="material-symbols-outlined">
                                    edit
                                </span>
                                {t('Manage Enrolments')}
                            </a>
                        </div>
                    }
                    {(!authenticationStatus.user.agentCodes || !(authenticationStatus.user.agentCodes.length > 0)) &&
                        <div>
                            {t('Your account is not associated with any agent codes. Please contact your administrator.')}
                        </div>
                    }
                    {authenticationStatus.isAuthenticated &&
                        <div>
                            <a href="#" onClick={() => {
                                logout().then(() => {
                                    window.location = '/login';
                                });
                            }}>
                                <span className="material-symbols-outlined">
                                    logout
                                </span>
                                {t('Logout')}
                            </a>
                        </div>
                    }

                    <div>Version {packageJson.version} ({packageJson.versionDate})</div>

                </div>
            </div>
        )
    }
}

export default Dashboard;
